export default function ReportValueMiniSlider({
  fieldName,
  value,
  valueRanges,
}: {
  fieldName: string;
  value: number;
  valueRanges: { [key: string]: { min: number; max: number } };
}) {
  const min = valueRanges[fieldName].min;
  const max = valueRanges[fieldName].max;
  const percentage = ((value - min) / (max - min)) * 100;
  return (
    <div
      style={{
        position: "relative",
        width: "100px",
        minHeight: "15px",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "3px",
          left: "0px",
          top: "10%",
          transform: "translate(0%, -50%)",
          borderRadius: "3px",
          backgroundColor: "#a0adb74f",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: `${percentage}%`,
          height: "3px",
          left: "0px",
          top: "10%",
          transform: "translate(0%, -50%)",
          borderRadius: "3px",
          backgroundColor: "#0280e8",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: "8px",
          height: "8px",
          left: `${percentage}%`,
          top: "10%",
          transform: "translate(-50%, -50%)",
          borderRadius: "100px",
          backgroundColor: "#0280e8",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          left: "0px",
          bottom: "-8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "13px",
          opacity: "0.6",
        }}
      >
        <div>{min}</div>
        <div>{max}</div>
      </div>
    </div>
  );
}
